export interface AdCreativeFilters {
  platform?: string;
  status?: string;
}

/**
 * Apply the page's active platform/status filters to an ad_creatives query.
 *
 * Bulk actions refetch a release straight from the DB rather than reusing the
 * rows on screen, so without this they operate on creatives the user cannot
 * see — e.g. adding `rejected` rows while the page is filtered to `pending`.
 * Mirrors the filter logic in the store's fetchAdCreatives so the set acted on
 * is exactly the set that was counted.
 */
export function applyAdCreativeFilters(query: any, filters: AdCreativeFilters): any {
  let q = query;

  if (filters.status) {
    q = q.eq('status', filters.status);
  } else {
    // No explicit status → same default as the list: hide archived.
    q = q.neq('status', 'archived');
  }

  if (filters.platform === 'instagram') {
    q = q.or('platform.eq.instagram,merged_instagram_reel_url.not.is.null');
  } else if (filters.platform === 'tiktok') {
    q = q.or('platform.eq.tiktok,merged_tiktok_auth_code.not.is.null');
  } else if (filters.platform === 'video_files') {
    q = q.in('platform', ['dropbox', 'direct_upload']);
  } else if (filters.platform) {
    q = q.eq('platform', filters.platform);
  }

  return q;
}
